import React, { useCallback } from 'react';
import { AiOutlineMergeCells, AiOutlineSplitCells } from 'react-icons/ai';
import './ToggleView.css';

const ToggleView = ({toggle, cur}) => {
  const handleToggle = useCallback((e) => {
    toggle();
  }, [toggle]);

  return (
    <div className='toggleView' onClick={handleToggle}>
      <div>
        {cur && <AiOutlineSplitCells />  }
        {!cur && <AiOutlineMergeCells /> }
      </div>
      <div>
      </div>
    </div>
  )
}

export default React.memo(ToggleView);